import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { rightArrow, rightArrowHover, services1, services2, services3, services4, services5, services6, services7, services8, services9, subMenuHome, subMenuPartners, subMenuProjects, whyUs } from '../../../assets/images';
import { useParams } from 'react-router-dom';


const newsItems = [
  {
    id: 1,
    imgSrc: services1,
    title: 'İsitmə',
    description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq. Müştərilərimizin ehtiyaclarına uyğun effektiv və enerji sərfiyyatına qənaət edən həllər təklif edərək, onların rahatlığını və təhlükəsizliyini təmin etməyi hədəfləyirik. Peşəkar komandamız müasir texnologiyalardan və innovativ yanaşmalardan istifadə edərək, hər bir layihəni yüksək keyfiyyətlə həyata keçirir. Məqsədimiz yalnız funksional sistemlər qurmaq deyil, həm də müştərilərimizə uzunmüddətli etibarlı xidmət göstərərək, onların həyat keyfiyyətini artırmaqdır.',
  },
  {
    id: 2,
    imgSrc: services2,
    title: 'Ventilyasiya',
    description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq. Müştərilərimizin ehtiyaclarına uyğun effektiv və enerji sərfiyyatına qənaət edən həllər təklif edərək, onların rahatlığını və təhlükəsizliyini təmin etməyi hədəfləyirik. Peşəkar komandamız müasir texnologiyalardan və innovativ yanaşmalardan istifadə edərək, hər bir layihəni yüksək keyfiyyətlə həyata keçirir. Məqsədimiz yalnız funksional sistemlər qurmaq deyil, həm də müştərilərimizə uzunmüddətli etibarlı xidmət göstərərək, onların həyat keyfiyyətini artırmaqdır.',
  },
  {
    id: 3,
    imgSrc: services3,
    title: 'Soyutma, kondisionerləşdirmə',
    description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq. Müştərilərimizin ehtiyaclarına uyğun effektiv və enerji sərfiyyatına qənaət edən həllər təklif edərək, onların rahatlığını və təhlükəsizliyini təmin etməyi hədəfləyirik. Peşəkar komandamız müasir texnologiyalardan və innovativ yanaşmalardan istifadə edərək, hər bir layihəni yüksək keyfiyyətlə həyata keçirir. Məqsədimiz yalnız funksional sistemlər qurmaq deyil, həm də müştərilərimizə uzunmüddətli etibarlı xidmət göstərərək, onların həyat keyfiyyətini artırmaqdır.',
  },
  {
      id: 4,
      imgSrc: services4,
      title: 'Santexnika',
      description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq. Müştərilərimizin ehtiyaclarına uyğun effektiv və enerji sərfiyyatına qənaət edən həllər təklif edərək, onların rahatlığını və təhlükəsizliyini təmin etməyi hədəfləyirik. Peşəkar komandamız müasir texnologiyalardan və innovativ yanaşmalardan istifadə edərək, hər bir layihəni yüksək keyfiyyətlə həyata keçirir. Məqsədimiz yalnız funksional sistemlər qurmaq deyil, həm də müştərilərimizə uzunmüddətli etibarlı xidmət göstərərək, onların həyat keyfiyyətini artırmaqdır.',
    },
    {
      id: 5,
      imgSrc: services5,
      title: 'Yanğınsöndürmə',
      description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq. Müştərilərimizin ehtiyaclarına uyğun effektiv və enerji sərfiyyatına qənaət edən həllər təklif edərək, onların rahatlığını və təhlükəsizliyini təmin etməyi hədəfləyirik. Peşəkar komandamız müasir texnologiyalardan və innovativ yanaşmalardan istifadə edərək, hər bir layihəni yüksək keyfiyyətlə həyata keçirir. Məqsədimiz yalnız funksional sistemlər qurmaq deyil, həm də müştərilərimizə uzunmüddətli etibarlı xidmət göstərərək, onların həyat keyfiyyətini artırmaqdır.',
    },
    {
      id: 6,
      imgSrc: services6,
      title: 'Elektrik sistemləri',
      description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq. Müştərilərimizin ehtiyaclarına uyğun effektiv və enerji sərfiyyatına qənaət edən həllər təklif edərək, onların rahatlığını və təhlükəsizliyini təmin etməyi hədəfləyirik. Peşəkar komandamız müasir texnologiyalardan və innovativ yanaşmalardan istifadə edərək, hər bir layihəni yüksək keyfiyyətlə həyata keçirir. Məqsədimiz yalnız funksional sistemlər qurmaq deyil, həm də müştərilərimizə uzunmüddətli etibarlı xidmət göstərərək, onların həyat keyfiyyətini artırmaqdır.',
    },
    {
      id: 7,
      imgSrc: services7,
      title: 'Aşağı cərəyan',
       description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq. Müştərilərimizin ehtiyaclarına uyğun effektiv və enerji sərfiyyatına qənaət edən həllər təklif edərək, onların rahatlığını və təhlükəsizliyini təmin etməyi hədəfləyirik. Peşəkar komandamız müasir texnologiyalardan və innovativ yanaşmalardan istifadə edərək, hər bir layihəni yüksək keyfiyyətlə həyata keçirir. Məqsədimiz yalnız funksional sistemlər qurmaq deyil, həm də müştərilərimizə uzunmüddətli etibarlı xidmət göstərərək, onların həyat keyfiyyətini artırmaqdır.',
    },
    {
      id: 8,
      imgSrc: services8,
      title: 'Avtomatlaşdırma sistemləri',
       description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq. Müştərilərimizin ehtiyaclarına uyğun effektiv və enerji sərfiyyatına qənaət edən həllər təklif edərək, onların rahatlığını və təhlükəsizliyini təmin etməyi hədəfləyirik. Peşəkar komandamız müasir texnologiyalardan və innovativ yanaşmalardan istifadə edərək, hər bir layihəni yüksək keyfiyyətlə həyata keçirir. Məqsədimiz yalnız funksional sistemlər qurmaq deyil, həm də müştərilərimizə uzunmüddətli etibarlı xidmət göstərərək, onların həyat keyfiyyətini artırmaqdır.',
    },
    {
      id: 9,
      imgSrc: services9,
      title: 'Kanal sexi',
      description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq. Müştərilərimizin ehtiyaclarına uyğun effektiv və enerji sərfiyyatına qənaət edən həllər təklif edərək, onların rahatlığını və təhlükəsizliyini təmin etməyi hədəfləyirik. Peşəkar komandamız müasir texnologiyalardan və innovativ yanaşmalardan istifadə edərək, hər bir layihəni yüksək keyfiyyətlə həyata keçirir. Məqsədimiz yalnız funksional sistemlər qurmaq deyil, həm də müştərilərimizə uzunmüddətli etibarlı xidmət göstərərək, onların həyat keyfiyyətini artırmaqdır.',
    },
];
 
const ServicesDetailItems = () => {


      const { t } = useTranslation();

      const { id } = useParams();

      const [singleNews, setSingleNews] = useState("")

      useEffect(() => {


        const filteredTour = newsItems.find(product => product.id == id);
        setSingleNews(filteredTour);
    
      }, []);

  return (
    <div className='pt-[88px] md:pt-[104px] bg-[#FBFBFB]'>
       <div className='max-w-containerSm md:max-w-container mx-auto '>
        <div className='text-[#1C1C1C]'>
        {singleNews.description}
        </div>
        <div className='flex justify-between items-center mt-[72px]'>
      <p className='text-[#1C1C1C] font-medium text-[24px] mx-auto md:mx-0'>Digər xidmətlər</p>
       <a className='hidden md:block group' href='/services'>
                             <div className='flex justify-between items-center w-[144px] rounded-[12px] bg-[#FBFBFB] text-[#1C1C1C] h-[46px]'>
                                <p className='"transition-colors duration-300 group-hover:text-[#008A7F]'>Hamısına bax</p>
                                <img 
                                                      className='w-2 transition-opacity duration-300 group-hover:hidden'
                                                      src={rightArrow}
                                                      alt=""
                                                    />
                                                    <img
                                                      className='w-2 transition-opacity duration-300 hidden group-hover:block'
                                                      src={rightArrowHover}
                                                      alt=""
                                                    />
                              </div>
                             </a>
        </div>
       <div className='grid grid-cols-1 md:grid-cols-3 gap-5 mt-[32px]'>
        {newsItems.slice(0, 3).map((item) => (
        <div className='w-full border border-[#E5E5E5] rounded-lg hover:border hover:border-[#008A7F] transition-all duration-300'>
            <img src={item.imgSrc} className='w-full' alt='' />
            <div className='bg-[white] py-4 pl-4 rounded-lg'>
            <p className='text-[#1C1C1C] text-[20px] font-medium'>{item.title}</p>
            <p className='mt-4 text-[#1C1C1C]'>{item.description.slice(0, 80)}..</p>
             <a className='group' href={`/services/${item?.id}`}>
                        <div className='flex items-center mt-4 justify-between mx-auto md:mx-0 w-[90px] rounded-[12px] bg-[white] text-[#1C1C1C] h-[46px]'>
                        <p className='"transition-colors duration-300 group-hover:text-[#008A7F]'>Ətraflı</p>
                          <img 
                                                                                className='w-2 transition-opacity duration-300 group-hover:hidden'
                                                                                src={rightArrow}
                                                                                alt=""
                                                                              />
                                                                              <img
                                                                                className='w-2 transition-opacity duration-300 hidden group-hover:block'
                                                                                src={rightArrowHover}
                                                                                alt=""
                                                                              />
                        </div>
                      </a>
            </div>
        </div>
            ))}
                   <a className='block md:hidden' href='/services'>
                             <div className='flex justify-between items-center mx-auto w-[144px] rounded-[12px] bg-[#FBFBFB] text-[#1C1C1C] h-[46px]'>
                                <p>Hamısına bax</p>
                                <img className='w-2' src={rightArrow}></img>
                              </div>
                             </a>


    </div>
       </div>
    </div>
  )
}

export default ServicesDetailItems